// LivestreamPinnedMessages.js
'use strict';
import { connect } from 'react-redux';
import getLiveStreamPinnedMessages from '../selector/getLiveStreamPinnedMessages.js';
import LivestreamPinnedMessages from '../component/LivestreamPinnedMessages.jsx';

const mapStateToProps = (state, { streamId }) => {
  return {
    pinnedMessages: getLiveStreamPinnedMessages(state, streamId),
  };
};

export default connect(mapStateToProps)(LivestreamPinnedMessages);
